module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-edit-room"
  }, [_c('div', {
    staticClass: "ui very relaxed grid"
  }, [_c('div', {
    staticClass: "row two column stackable"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h3', [_vm._v("房间信息")]), _c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "three fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("房号")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.no),
      expression: "form.no"
    }],
    staticClass: "disabled",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.form.no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "no", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("楼层")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.category),
      expression: "form.category"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "category", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("名称")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("月租价格")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.price_month),
      expression: "form.price_month"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.price_month)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "price_month", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("日租价格")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.price_day),
      expression: "form.price_day"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.price_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "price_day", $event.target.value)
      }
    }
  })])]), (_vm.$config.logic.lezhu_meter) ? _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("乐住电表编号 (例: 333000100)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.lezhu_meter_id),
      expression: "form.lezhu_meter_id"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.form.lezhu_meter_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "lezhu_meter_id", $event.target.value)
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("备注")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.note),
      expression: "form.note"
    }],
    attrs: {
      "rows": "1"
    },
    domProps: {
      "value": (_vm.form.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "note", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "ui field"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "房间可用"
    },
    model: {
      value: (_vm.form.avaliable),
      callback: function($$v) {
        _vm.$set(_vm.form, "avaliable", $$v)
      },
      expression: "form.avaliable"
    }
  })], 1)]), _c('br'), _c('br'), (_vm.$permission.has("basic.modify.rooms.history_notes")) ? _c('auto-edit-table', {
    attrs: {
      "defines": _vm.$defines.history_notes,
      "form-meta": {
        room_id: _vm.room._id
      },
      "title": "房屋记录",
      "data": _vm.room.history_notes || [],
      "detail-view": false,
      "button-add": true
    }
  }, [_c('h3', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("房屋记录")])]) : _vm._e()], 1), _c('div', {
    staticClass: "column"
  }, [(_vm.$permission.has("basic.modify.rooms.properties")) ? _c('h3', {
    staticClass: "with-actions"
  }, [_c('span', [_vm._v("物品清单")]), _c('div', {
    staticClass: "ui buttons actions"
  }, [_c('div', {
    staticClass: "ui basic icon button",
    on: {
      "click": function($event) {
        _vm.dialogVisiable = true
      }
    }
  }, [_c('i', {
    staticClass: "icon pencil themed text"
  })])])]) : _vm._e(), _c('room-properties', {
    attrs: {
      "properties": _vm.form.properties
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ui button themed",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认修改")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])]), _c('dialog-edit-properties', {
    attrs: {
      "properties": _vm.form.properties,
      "visible": _vm.dialogVisiable
    },
    on: {
      "update:properties": function($event) {
        _vm.$set(_vm.form, "properties", $event)
      },
      "update:visible": function($event) {
        _vm.dialogVisiable = $event
      },
      "exit": function($event) {
        _vm.dialogVisiable = false
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-532efd2a","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/FormEditRoom.vue
// module id = 392
// module chunks = 0